@if (data$ | async) {
  <div class="flow">
    <ng-container>
      <mat-horizontal-stepper linear #stepper class="no-stepper-nav" (selectionChange)="selectionChange($event)">
        <mat-step #abonnementStep>
          <div class="flow__nav">
            <button class="btn-icon blue" type="button" (click)="goToSubscription()">
              <mat-icon>chevron_left</mat-icon>
              <span>Tilbage</span>
            </button>
            <button class="btn-close btn-icon" (click)="onCloseClick()" title="Luk">
              <mat-icon svgIcon="remove"></mat-icon>
            </button>
            <a class="blue" (click)="quickViewOpen = true">Se aftale</a>
          </div>
          <div class="flow__stage">
            <div class="flow__step-content">
              <ng-container *ngTemplateOutlet="stepHeader"></ng-container>
              <h1 class="medium">Hvilket abonnement ønsker kunden?</h1>
              <form [formGroup]="abonnementForm" [attr.autocomplete]="'off'">
                <div class="form-row">
                  <label class="form-headline">Abonnement</label>
                  <mat-radio-group formControlName="abonnement" (change)="onAbonnementChange($event)">
                    @for (a of abonnementer; track a) {
                      <mat-radio-button [disabled]="a.id == serviceaftale?.serviceAbonnement?.id" [value]="a.id">
                        {{ a.description }}
                      </mat-radio-button>
                    }
                  </mat-radio-group>
                </div>
              </form>
              <div class="flow__step-actions">
                <button mat-raised-button matStepperNext color="primary" [disabled]="!abonnementForm?.dirty || abonnementForm?.invalid">
                  Videre
                </button>
              </div>
            </div>
            <ng-container *ngTemplateOutlet="flowResume"></ng-container>
          </div>
        </mat-step>
        @if (!serviceaftale?.serviceAbonnement?.isTilkaldsabonnement && !selectedAbonnement?.isTilkaldsabonnement && !upcomingChange) {
          <mat-step
            #periodeStep
            >
            <div class="flow__nav">
              <button class="btn-icon blue" type="button" (click)="goToSubscription()">
                <mat-icon>chevron_left</mat-icon>
                <span>Tilbage</span>
              </button>
              <button class="btn-close btn-icon" (click)="onCloseClick()" title="Luk">
                <mat-icon svgIcon="remove"></mat-icon>
              </button>
              <a class="blue" (click)="quickViewOpen = true">Se aftale</a>
            </div>
            <div class="flow__stage">
              <div class="flow__step-content">
                <ng-container *ngTemplateOutlet="stepHeader"></ng-container>
                <h1 class="medium">
                  Serviceperioden er i gang!
                  <br />
                  <span class="regular">Hvad skal der ske?</span>
                </h1>
                <ng-container *ngTemplateOutlet="legend"></ng-container>
                <div>
                  <form [formGroup]="periodeForm" [attr.autocomplete]="'off'">
                    <mat-radio-group formControlName="tilpas" class="strong-labels" (change)="onPeriodeChange($event)">
                      <div class="flow__opt-detail">
                        <mat-radio-button [disabled]="!isTilpasningMulig" [value]="isTilpasningMulig">Tilpas eksisterende</mat-radio-button>
                        <div class="flex-wrap flex-wrap--flex-start">
                          <!-- <span class="warning" *ngIf="!isTilpasningMulig">Tilpasning af serviceinterval er ikke mulig, da...</span> -->
                          @if (isTilpasningMulig) {
                            <app-serviceinterval-change-graph
                              [serviceaftale]="serviceaftale"
                              [headline1]="'Eksisterende periode'"
                              [headline2]="'Tilpasset periode'"
                              [serviceinterval1]="currentServiceinterval"
                              [serviceinterval2]="tilpassetServiceinterval"
                              [naesteEftersynDate]="naesteEftersynDate.value"
                              [opkraevningDate]="opkraevningDate.value"
                            ></app-serviceinterval-change-graph>
                          }
                        </div>
                      </div>
                      <div class="flow__opt-detail">
                        <mat-radio-button [value]="false">Lav nyt serviceinterval</mat-radio-button>
                        <div class="flex-wrap flex-wrap--flex-start">
                          <app-serviceinterval-change-graph
                            [serviceaftale]="serviceaftale"
                            [headline1]="'Eksisterende periode'"
                            [headline2]="'Ny periode'"
                            [serviceinterval1]="currentServiceinterval"
                            [serviceinterval2]="nytServiceinterval"
                            [naesteEftersynDate]="naesteEftersynDate.value"
                            [opkraevningDate]="opkraevningDate.value"
                          ></app-serviceinterval-change-graph>
                        </div>
                      </div>
                    </mat-radio-group>
                  </form>
                </div>
                <div class="flow__step-actions">
                  <button mat-raised-button matStepperNext color="primary" [disabled]="$safeNavigationMigration(periodeForm?.invalid)">Videre</button>
                </div>
              </div>
              <ng-container *ngTemplateOutlet="flowResume"></ng-container>
            </div>
          </mat-step>
        }
        @if (!selectedAbonnement?.isTilkaldsabonnement) {
          <mat-step #datoStep>
            <div class="flow__nav">
              <button class="btn-icon blue" type="button" (click)="goToSubscription()">
                <mat-icon>chevron_left</mat-icon>
                <span>Tilbage</span>
              </button>
              <button class="btn-close btn-icon" (click)="onCloseClick()" title="Luk">
                <mat-icon svgIcon="remove"></mat-icon>
              </button>
              <a class="blue" (click)="quickViewOpen = true">Se aftale</a>
            </div>
            <div class="flow__stage">
              <div class="flow__step-content">
                <ng-container *ngTemplateOutlet="stepHeader"></ng-container>
                <h1 class="medium">Tilpas datoer?</h1>
                <ng-container *ngTemplateOutlet="legend"></ng-container>
                <form [formGroup]="datoForm" [attr.autocomplete]="'off'">
                  <div class="flex-wrap flex-wrap--flex-start">
                    <app-serviceinterval-change-graph
                      [serviceaftale]="serviceaftale"
                      [headline1]="'Eksisterende periode'"
                      [headline2]="tilpas.value ? 'Tilpasset periode' : 'Ny periode'"
                      [serviceinterval1]="currentServiceinterval"
                      [serviceinterval2]="selectedServiceinterval"
                      [naesteEftersynDate]="naesteEftersynDate.value"
                      [opkraevningDate]="opkraevningDate.value"
                    ></app-serviceinterval-change-graph>
                  </div>
                  @if (!selectedAbonnement || !selectedAbonnement?.isTilkaldsabonnement) {
                    <div class="form-row">
                      <mat-form-field appearance="outline">
                        <mat-label>Næste eftersyn</mat-label>
                        <mat-datepicker-toggle matPrefix [for]="checkupPicker"></mat-datepicker-toggle>
                        <input
                          #checkupInput
                          matInput
                          [matDatepicker]="checkupPicker"
                          [min]="minCheckupDate"
                          formControlName="naesteEftersynDate"
                          />
                          <mat-datepicker #checkupPicker></mat-datepicker>
                          <span
                            class="period__month period__month--solid naesteEftersynDate cursor-help"
                            matSuffix
                            [matTooltip]="'Næste eftersyn'"
                          ></span>
                        </mat-form-field>
                      </div>
                    }
                    <!-- <div class="form-row margin-bottom-x2" *ngIf="selectedAbonnement && !selectedAbonnement?.isTilkaldsabonnement">
                    <mat-label>Eftersynsinterval: </mat-label>
                    <span>{{ selectedAbonnement.eftersynInterval }} Måneder</span>
                  </div> -->
                  @if (!selectedAbonnement || !selectedAbonnement.isTilkaldsabonnement) {
                    <div class="form-row">
                      <mat-form-field appearance="outline">
                        <mat-label>Opkrævningsdato</mat-label>
                        <mat-datepicker-toggle matPrefix [for]="opkraevningsPicker"></mat-datepicker-toggle>
                        <input
                          #opkraevningsInput
                          matInput
                          [matDatepicker]="opkraevningsPicker"
                          [min]="minPaymentDate"
                          formControlName="opkraevningDate"
                          />
                          <mat-datepicker #opkraevningsPicker></mat-datepicker>
                          <span
                            class="period__month period__month--solid opkraevningDate cursor-help"
                            matSuffix
                            [matTooltip]="'Opkrævningsdato'"
                          ></span>
                        </mat-form-field>
                      </div>
                    }
                    @if (serviceaftale?.effectiveOpkraevningsinterval != selectedAbonnement?.opkraevningInterval) {
                      <div>
                        Bemærk det valgte abonnement afviger fra det oprindelige opkrævningsinterval (hver
                        {{ serviceaftale?.serviceAbonnement?.opkraevningInterval }} måned), og kunden vil få opkrævningsintervallet fra det nye
                        (hver {{ selectedAbonnement?.opkraevningInterval }}. måned)
                      </div>
                    }
                    @if (serviceaftale && serviceaftale.opkraevningsinterval && !selectedAbonnement?.isTilkaldsabonnement) {
                      <div>
                        Bemærk kunden har hidtil haft opkrævningsinterval, der afviger fra normalen. Tag venligst stilling til rette
                        opkrævningsinterval i forbindelse med skift af abonnement.
                      </div>
                    }
                    @if (selectedAbonnement && !selectedAbonnement?.isTilkaldsabonnement) {
                      <div class="form-row margin-bottom-x2">
                        <mat-label>Opkrævningsinterval:</mat-label>
                        @if (!opkraevningsinterval.value) {
                          <span>{{ selectedAbonnement.opkraevningInterval }} måneder</span>
                        }
                        @if (opkraevningsinterval.value) {
                          <span
                            [matTooltipDisabled]="opkraevningsinterval.value == selectedAbonnement.opkraevningInterval"
                  [matTooltip]="
                    'Opkrævningsintervallet afviger fra det normale på ' +
                    selectedAbonnement.opkraevningInterval +
                    ' måneder via abonnementet'
                  "
                            >
                            {{ opkraevningsinterval.value }} måneder
                          </span>
                        }
                        <button
                          type="button"
                          class="btn-icon blue inline-flex"
                          matTooltip="Rediger opkrævningsinterval"
                          (click)="openOpkraevningsIntervalDialog()"
                          >
                          - rediger interval
                        </button>
                        @if (opkraevningsinterval.value) {
                          <button
                            (click)="clearOpkraevningsInterval()"
                            class="btn-icon red"
                            aria-label="Fjern specielt opkrævningsinterval"
                            matTooltip="Fjern specielt opkrævningsinterval"
                            >
                            <mat-icon svgIcon="delete"></mat-icon>
                            Fjern specielt opkrævningsinterval
                          </button>
                        }
                        @if (datoForm.errors?.opkraevningsinterval) {
                          <mat-error>
                            Abonnementets Eftersynsinterval skal være deleligt med det angivne Opkraevningsinterval.
                          </mat-error>
                        }
                      </div>
                    }
                  </form>
                  <div class="flow__step-actions">
                    <button mat-raised-button matStepperNext color="primary" [disabled]="$safeNavigationMigration(datoForm?.invalid)">Videre</button>
                  </div>
                </div>
                <ng-container *ngTemplateOutlet="flowResume"></ng-container>
              </div>
            </mat-step>
          }
          @if (!selectedAbonnement?.isTilkaldsabonnement) {
            <mat-step #tilvalgStep>
              <div class="flow__nav">
                <button matStepperPrevious class="btn-icon blue" type="button">
                  <mat-icon>chevron_left</mat-icon>
                  <span>Tilbage</span>
                </button>
                <button class="btn-close btn-icon" (click)="onCloseClick()" title="Luk">
                  <mat-icon svgIcon="remove"></mat-icon>
                </button>
                <a class="blue" (click)="quickViewOpen = true">Se aftale</a>
              </div>
              <div class="flow__stage">
                <div class="flow__step-content">
                  <ng-container *ngTemplateOutlet="stepHeader"></ng-container>
                  <h1 class="medium">Hvilke tilvalg ønsker kunden?</h1>
                  <app-edit-tilvalg-form
                    [form]="tilvalgForm"
                    [tilvalgGroups]="selectedTilvalgGroups"
                    [serviceaftale]="serviceaftale"
                    [serviceaftaleChanged]="serviceaftale?.serviceAbonnement?.id != selectedAbonnement?.id"
                  ></app-edit-tilvalg-form>
                  <div class="flow__step-actions">
                    <button mat-raised-button matStepperNext color="primary" [disabled]="!tilvalgForm?.dirty || tilvalgForm?.invalid">
                      Videre
                    </button>
                  </div>
                </div>
                <ng-container *ngTemplateOutlet="flowResume"></ng-container>
              </div>
            </mat-step>
          }
          @if (afregninger?.length > 0 && !upcomingChange) {
            <mat-step #krediterstep>
              <div class="flow__nav">
                <button matStepperPrevious class="btn-icon blue" type="button">
                  <mat-icon>chevron_left</mat-icon>
                  <span>Tilbage</span>
                </button>
                <button class="btn-close btn-icon" (click)="onCloseClick()" title="Luk">
                  <mat-icon svgIcon="remove"></mat-icon>
                </button>
                <a class="blue" (click)="quickViewOpen = true">Se aftale</a>
              </div>
              <div class="flow__stage">
                <div class="flow__step-content">
                  <ng-container *ngTemplateOutlet="stepHeader"></ng-container>
                  <h1 class="medium">
                    Der er allerede sket {{ afregninger?.length }} opkrævninger!
                    <br />
                    <span class="regular">Hvad skal der ske?</span>
                  </h1>
                  <div>
                    <form [formGroup]="opkraevningForm" [attr.autocomplete]="'off'">
                      <mat-radio-group formControlName="opkraevningType" class="strong-labels">
                        <div class="flow__opt-detail">
                          <mat-radio-button [value]="true">Krediter tidligere opkrævning og opkræv på ny</mat-radio-button>
                          @if (currentPrice?.fastprisaftale || newPrice?.fastprisaftale) {
                            <div class="fastprisaftale orange icon-with-text">
                              <mat-icon svgIcon="obs-solid" class="orange margin--right-xs"></mat-icon>
                              <span>En eller flere opkrævninger er med fastprisaftale</span>
                            </div>
                          }
                          <div class="flex-wrap flex-wrap--flex-start">
                            <div>
                              <strong>Opkrævninger til gammel pris</strong>
                              <table class="tiny-text">
                                @for (opkraevning of afregninger; track opkraevning) {
                                  <tr>
                                    <td>Abn. opkrævning d. {{ opkraevning.opkraevningDate | date: 'dd.MM.yyyy' }}</td>
                                    <td class="align-right">
                                      @if (currentPrice?.preferredShownWithMoms) {
                                        <div>
                                          <strong>{{ opkraevning.beloebMedMoms | dkCurrency }}</strong>
                                        </div>
                                      }
                                      @if (!currentPrice?.preferredShownWithMoms) {
                                        <div>
                                          <strong>
                                            {{ opkraevning.beloebMedMoms | dkCurrency }}
                                            <span class="cursor-help" matTooltip="Ekskl. moms">
                                              <span ngNonBindable>&#123;</span>
                                              {{ opkraevning.beloebExclMoms | dkCurrency }}&#125;
                                            </span>
                                          </strong>
                                        </div>
                                      }
                                    </td>
                                  </tr>
                                }
                              </table>
                            </div>
                            <div class="flow__arrow">
                              <mat-icon class="orange">chevron_right</mat-icon>
                            </div>
                            <div class="orange">
                              <strong>Opkrævninger til ny pris</strong>
                              @if (selectedAbonnement?.isTilkaldsabonnement) {
                                <div>Ingen abonnementsopkrævning, jf. tilkaldsaftale</div>
                              }
                              @if (!selectedAbonnement?.isTilkaldsabonnement) {
                                <table class="tiny-text">
                                  @for (op of afregninger; track op) {
                                    <tr>
                                      <td>Ny opkrævning</td>
                                      <td class="align-right">
                                        @if (!priceForKorrektion) {
                                          <div>Prisen kunne ikke beregnes</div>
                                        }
                                        @if (priceForKorrektion) {
                                          @if (priceForKorrektion?.preferredShownWithMoms) {
                                            <div>
                                              <strong>{{ priceForKorrektion?.opkraevning.amount.withMoms | dkCurrency }}</strong>
                                            </div>
                                          }
                                          @if (!priceForKorrektion?.preferredShownWithMoms) {
                                            <div>
                                              <strong>
                                                {{ priceForKorrektion?.opkraevning.amount.withMoms | dkCurrency }}
                                                <span class="cursor-help" matTooltip="Ekskl. moms">
                                                  <span ngNonBindable>&#123;</span>
                                                  {{ priceForKorrektion?.opkraevning.amount.withoutMoms | dkCurrency }}&#125;
                                                </span>
                                              </strong>
                                            </div>
                                          }
                                        }
                                      </td>
                                    </tr>
                                  }
                                </table>
                              }
                            </div>
                          </div>
                        </div>
                        <div>
                          <mat-radio-button [value]="false">Prisændring gælder kun fremadrettet</mat-radio-button>
                        </div>
                      </mat-radio-group>
                    </form>
                  </div>
                  <div>
                    <button mat-raised-button matStepperNext color="primary" [disabled]="!opkraevningForm?.dirty || opkraevningForm?.invalid">
                      Videre
                    </button>
                  </div>
                </div>
                <ng-container *ngTemplateOutlet="flowResume"></ng-container>
              </div>
            </mat-step>
          }
          @if (!isGarantiNaerVarmeLeasingGasTryghed) {
            <mat-step #sendLetterStep>
              <div class="flow__nav">
                <button matStepperPrevious class="btn-icon blue" type="button">
                  <mat-icon>chevron_left</mat-icon>
                  <span>Tilbage</span>
                </button>
                <button class="btn-close btn-icon" (click)="onCloseClick()" title="Luk">
                  <mat-icon svgIcon="remove"></mat-icon>
                </button>
                <a class="blue" (click)="quickViewOpen = true">Se aftale</a>
              </div>
              <div class="flow__stage">
                <div class="flow__step-content">
                  <h1 class="medium">Skal der sendes et brev til kunden?</h1>
                  <app-send-letter
                    [form]="sendLetterForm"
                    [email]="$safeNavigationMigration(serviceaftale?.kunde?.anlaegsadresse?.email)"
                    (reload)="reloadServiceAftale()"
                  ></app-send-letter>
                  <div class="flow__step-actions">
                    <button mat-raised-button matStepperNext color="primary" [disabled]="$safeNavigationMigration(sendLetterForm?.invalid)">Videre</button>
                  </div>
                </div>
              </div>
            </mat-step>
          }
          <mat-step #confirmstep>
            <div class="flow__nav">
              <button matStepperPrevious class="btn-icon blue" type="button">
                <mat-icon>chevron_left</mat-icon>
                <span>Tilbage</span>
              </button>
              <button class="btn-close btn-icon" (click)="onCloseClick()" title="Luk">
                <mat-icon svgIcon="remove"></mat-icon>
              </button>
              <a class="blue" (click)="quickViewOpen = true">Se aftale</a>
            </div>
            <div class="flow__stage">
              <div class="flow__step-confirm">
                <ng-container *ngTemplateOutlet="stepHeader"></ng-container>
                @if (!upcomingChange) {
                  <h1 class="medium">Er disse ændringer korrekte?</h1>
                }
                @if (upcomingChange) {
                  <h1 class="medium">
                    Ændringen træder i kraft d. {{ validFrom | date: 'dd.MM.yyyy' }}
                    @if (currentServiceinterval) {
                      <span>når nuværende serviceperiode er slut</span>
                    }
                  </h1>
                }
                <div class="flow__opt-detail margin--top-xl">
                  <div class="flex-wrap flex-wrap--flex-start" (click)="goToStep(0)">
                    <div>
                      <div>Serviceabonnement</div>
                      <strong>{{ serviceaftale?.serviceAbonnement?.description }}</strong>
                    </div>
                    <div class="flow__arrow">
                      <mat-icon class="orange">chevron_right</mat-icon>
                      <mat-icon class="blue" svgIcon="edit"></mat-icon>
                    </div>
                    <div class="orange">
                      <div>
                        <div>Nyt serviceabonnement</div>
                        <strong>{{ selectedAbonnement?.description }}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="flex-wrap flex-wrap--flex-start" (click)="goToStep(0)">
                    <div>
                      <div>Tilvalg</div>
                      @if (!serviceaftale?.serviceAbonnement?.isTilkaldsabonnement) {
                        @for (tilvalgGroup of tilvalgGroups; track tilvalgGroup) {
                          <strong>
                            {{ getCurrentTilvalg(tilvalgGroup) }}
                            <br />
                          </strong>
                        }
                      }
                      @if (serviceaftale?.serviceAbonnement?.isTilkaldsabonnement) {
                        <strong>Ingen tilvalg</strong>
                      }
                    </div>
                    <div class="flow__arrow">
                      <mat-icon class="orange">chevron_right</mat-icon>
                      <mat-icon class="blue" svgIcon="edit"></mat-icon>
                    </div>
                    <div class="orange">
                      <div>
                        <div>Tilvalg</div>
                        @if (!selectedAbonnement?.isTilkaldsabonnement) {
                          @for (tilvalgGroup of selectedTilvalgGroups; track tilvalgGroup) {
                            <strong>
                              {{ getNewTilvalg(tilvalgGroup) }}
                              <br />
                            </strong>
                          }
                        }
                        @if (selectedAbonnement?.isTilkaldsabonnement) {
                          <strong>Ingen tilvalg</strong>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="flex-wrap flex-wrap--flex-start" (click)="goToStep(0)">
                    <div>
                      <div>Næste eftersyn</div>
                      @if (!serviceaftale?.serviceAbonnement?.isTilkaldsabonnement) {
                        <strong>{{ $safeNavigationMigration(serviceaftale?.naesteEftersynDate) | date: 'dd.MM.yyyy' }}</strong>
                      }
                      @if (serviceaftale?.serviceAbonnement?.isTilkaldsabonnement) {
                        <strong>Ingen eftersyn</strong>
                      }
                    </div>
                    <div class="flow__arrow">
                      <mat-icon class="orange">chevron_right</mat-icon>
                      <mat-icon class="blue" svgIcon="edit"></mat-icon>
                    </div>
                    <div class="orange">
                      <div>
                        <div>Nyt næste eftersyn</div>
                        @if (!selectedAbonnement?.isTilkaldsabonnement) {
                          <strong>{{ naesteEftersynDate.value | date: 'dd.MM.yyyy' }}</strong>
                        }
                        @if (selectedAbonnement?.isTilkaldsabonnement) {
                          <strong>Ingen eftersyn</strong>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="flex-wrap flex-wrap--flex-start" (click)="goToStep(0)">
                    <div>
                      <div>Opkrævningsdato</div>
                      @if (!serviceaftale?.serviceAbonnement?.isTilkaldsabonnement) {
                        <strong>{{ $safeNavigationMigration(serviceaftale?.opkraevningDate) | date: 'dd.MM.yyyy' }}</strong>
                      }
                      @if (serviceaftale?.serviceAbonnement?.isTilkaldsabonnement) {
                        <strong>Ingen opkrævning</strong>
                      }
                    </div>
                    <div class="flow__arrow">
                      <mat-icon class="orange">chevron_right</mat-icon>
                      <mat-icon class="blue" svgIcon="edit"></mat-icon>
                    </div>
                    <div class="orange">
                      <div>
                        <div>Ny opkrævningsdato</div>
                        @if (!selectedAbonnement?.isTilkaldsabonnement) {
                          <strong>{{ opkraevningDate.value | date: 'dd.MM.yyyy' }}</strong>
                        }
                        @if (selectedAbonnement?.isTilkaldsabonnement) {
                          <strong>Ingen opkrævning</strong>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="flex-wrap flex-wrap--flex-start" (click)="goToStep(0)">
                    <div>
                      <div>Serviceinterval</div>
                      @if (!serviceaftale?.serviceAbonnement?.isTilkaldsabonnement) {
                        <strong>{{ serviceaftale?.serviceAbonnement?.eftersynInterval }} mdr.</strong>
                      }
                      @if (serviceaftale?.serviceAbonnement?.isTilkaldsabonnement) {
                        <strong>Ingen serviceinterval</strong>
                      }
                    </div>
                    <div class="flow__arrow">
                      <mat-icon class="orange">chevron_right</mat-icon>
                      <mat-icon class="blue" svgIcon="edit"></mat-icon>
                    </div>
                    <div class="orange">
                      <div>
                        <div>Nyt serviceinterval</div>
                        @if (!selectedAbonnement?.isTilkaldsabonnement) {
                          <strong>{{ eftersynInterval.value }} mdr.</strong>
                        }
                        @if (selectedAbonnement?.isTilkaldsabonnement) {
                          <strong>Ingen serviceinterval</strong>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="flex-wrap flex-wrap--flex-start" (click)="goToStep(0)">
                    <div>
                      <div>Opkrævningsinterval</div>
                      @if (!serviceaftale?.serviceAbonnement?.isTilkaldsabonnement) {
                        <strong>{{ serviceaftale?.effectiveOpkraevningsinterval }} mdr.</strong>
                      }
                      @if (serviceaftale?.serviceAbonnement?.isTilkaldsabonnement) {
                        <strong>Intet opkrævningsinterval</strong>
                      }
                    </div>
                    <div class="flow__arrow">
                      <mat-icon class="orange">chevron_right</mat-icon>
                      <mat-icon class="blue" svgIcon="edit"></mat-icon>
                    </div>
                    <div class="orange">
                      <div>
                        <div>Nyt opkrævningsinterval</div>
                        @if (!selectedAbonnement?.isTilkaldsabonnement) {
                          @if (opkraevningsinterval.value) {
                            <strong>{{ opkraevningsinterval.value }} mdr.</strong>
                          }
                        }
                        @if (selectedAbonnement?.isTilkaldsabonnement) {
                          <strong>Intet opkrævningsinterval</strong>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="flex-wrap flex-wrap--flex-start" (click)="goToStep(0)">
                    <div>
                      <div>Tidligere opkrævet i alt</div>
                      @if (afregninger.length > 0) {
                        @if (currentPrice?.preferredShownWithMoms) {
                          <strong>{{ afregningerTotalMedMoms | dkCurrency }}</strong>
                        }
                        @if (!currentPrice?.preferredShownWithMoms) {
                          <strong>
                            {{ afregningerTotalMedMoms | dkCurrency }}
                            <span class="cursor-help" matTooltip="Ekskl. moms">
                              <span ngNonBindable>&#123;</span>
                              {{ afregningerTotalExclMoms | dkCurrency }}&#125;
                            </span>
                          </strong>
                        }
                      }
                      @if (afregninger.length == 0) {
                        <strong>{{ 0 | dkCurrency }}</strong>
                      }
                    </div>
                    <div class="flow__arrow">
                      <mat-icon class="orange">chevron_right</mat-icon>
                      <mat-icon class="blue" svgIcon="edit"></mat-icon>
                    </div>
                    <div class="orange">
                      @if (opkraevningType.value) {
                        <div>
                          <div>Korrektion tidl. opkræver (i alt)</div>
                          <strong>
                            Krediteres:
                            @if (currentPrice?.preferredShownWithMoms) {
                              {{ afregningerTotalMedMoms * -1 | dkCurrency }}
                            }
                            @if (!currentPrice?.preferredShownWithMoms) {
                              {{ afregningerTotalMedMoms * -1 | dkCurrency }}
                              <span class="cursor-help" matTooltip="Ekskl. moms">
                                <span ngNonBindable>&#123;</span>
                                {{ afregningerTotalExclMoms * -1 | dkCurrency }}&#125;
                              </span>
                            }
                          </strong>
                          <br />
                          <strong>
                            Opkræves ny pris:
                            @if (priceForKorrektion?.preferredShownWithMoms) {
                              <div>
                                <strong>{{ opkraevningerTotalMedMoms | dkCurrency }}</strong>
                              </div>
                            }
                            @if (!priceForKorrektion?.preferredShownWithMoms) {
                              <div>
                                <strong>
                                  {{ opkraevningerTotalMedMoms | dkCurrency }}
                                  <span class="cursor-help" matTooltip="Ekskl. moms">
                                    <span ngNonBindable>&#123;</span>
                                    {{ opkraevningerTotalExclMoms | dkCurrency }}&#125;
                                  </span>
                                </strong>
                              </div>
                            }
                          </strong>
                        </div>
                      }
                      @if (!opkraevningType.value) {
                        <div>
                          <div>Korrektion tidl. opkræver (i alt)</div>
                          <strong>Ingen korrektion</strong>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="flex-wrap flex-wrap--flex-start" (click)="goToStep(0)">
                    <div>
                      <div>Gammel pris</div>
                      @if (currentPrice?.preferredShownWithMoms) {
                        <strong>{{ $safeNavigationMigration(currentPrice?.listPrice.withMoms) | dkCurrency }}</strong>
                      }
                      @if (!currentPrice?.preferredShownWithMoms) {
                        <strong>
                          {{ $safeNavigationMigration(currentPrice?.listPrice.withMoms) | dkCurrency }}
                          <span class="cursor-help" matTooltip="Ekskl. moms">
                            <span ngNonBindable>&#123;</span>
                            {{ $safeNavigationMigration(currentPrice?.listPrice.withoutMoms) | dkCurrency }}&#125;
                          </span>
                        </strong>
                      }
                    </div>
                    <div class="flow__arrow">
                      <mat-icon class="orange">chevron_right</mat-icon>
                      <mat-icon class="blue" svgIcon="edit"></mat-icon>
                    </div>
                    <div class="orange">
                      <div>
                        <div>Ny pris</div>
                        @if (!newPrice) {
                          <span [matTooltip]="priceError" [matTooltipDisabled]="!priceError"><strong>Kan ikke beregnes</strong></span>
                        }
                        @if (newPrice && newPrice.preferredShownWithMoms) {
                          <strong>{{ $safeNavigationMigration(newPrice?.listPrice.withMoms) | dkCurrency }}</strong>
                        }
                        @if (newPrice && !newPrice.preferredShownWithMoms) {
                          <strong>
                            {{ $safeNavigationMigration(newPrice?.listPrice.withMoms) | dkCurrency }}
                            <span class="cursor-help" matTooltip="Ekskl. moms">
                              <span ngNonBindable>&#123;</span>
                              {{ $safeNavigationMigration(newPrice?.listPrice.withoutMoms) | dkCurrency }}&#125;
                            </span>
                          </strong>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="margin--top-l" />
                <div class="align-center margin--top-l">
                  <button mat-raised-button color="primary" (click)="doChange(stepper)" [disabled]="">Gennemfør ændringer</button>
                </div>
              </div>
            </div>
          </mat-step>
          <mat-step #fourthstep>
            <div class="flow__nav"></div>
            <div class="flow__stage">
              <div class="flow__step-confirm align-center green">
                <mat-icon svgIcon="checkmark" class="icon-64"></mat-icon>
                <br />
                <h2 class="medium">Abonnementet er nu ændret</h2>
                @if (upcomingChange) {
                  <div>Træder i kraft fra d. {{ validFrom | date: 'dd.MM.yyyy' }}</div>
                }
                <div class="flow__step-actions">
                  <button mat-raised-button color="primary" replaceUrl="true" [routerLink]="['/aftale/', $safeNavigationMigration(serviceaftale?.okKundeAftaleNr)]">
                    Gå til aftalen
                  </button>
                </div>
              </div>
            </div>
          </mat-step>
        </mat-horizontal-stepper>
      </ng-container>
      <ng-template #legend>
        <div style="max-width: 800px" class="period flex-wrap margin--bottom-m">
          <div>
            <span class="period__month period__month--solid opkraevning">&nbsp;</span>
            <span>Opkrævning</span>
          </div>
          <div>
            <span class="period__month period__month--solid eftersyn">&nbsp;</span>
            <span>Eftersyn</span>
          </div>
          <div>
            <span class="period__month naesteEftersynDate">&nbsp;</span>
            <span>Kommende eftersyn</span>
          </div>
          <div>
            <span class="period__month opkraevningDate">&nbsp;</span>
            <span>Kommende opkrævning</span>
          </div>
          <div>
            <span class="period__offset startDate">&nbsp;</span>
            <span>Start</span>
          </div>
          <div>
            <span class="period__offset endDate">&nbsp;</span>
            <span>Opsagt</span>
          </div>
        </div>
      </ng-template>
      <ng-template #flowResume>
        <div class="flow__resume">
          <div @fadeSlideInOut>
            <div class="h2 medium">
              Nuværende abonnement
              <br />
              <span class="orange regular">med [rettelser]</span>
            </div>
            <div class="margin--top-l">
              <strong>Serviceabonnement</strong>
              <br />
              {{ serviceaftale?.serviceAbonnement?.description }}
              <br />
              @if (selectedAbonnement) {
                <span class="orange absolute" @fadeSlideInOut>[{{ selectedAbonnement?.description }}]</span>
              }
            </div>
            <div class="margin--top-l">
              <strong>
                Tilvalg
                <br />
              </strong>
              @if (serviceaftale?.serviceAbonnement.isTilkaldsabonnement) {
                <span>Ingen tilvalg</span>
              }
              @if (!serviceaftale?.serviceAbonnement.isTilkaldsabonnement) {
                @for (tilvalgGroup of tilvalgGroups; track tilvalgGroup) {
                  <span>
                    {{ getCurrentTilvalg(tilvalgGroup) }}
                    <br />
                  </span>
                }
              }
              <br />
              @if (selectedAbonnement?.isTilkaldsabonnement) {
                <span class="orange absolute" @fadeSlideInOut>[Ingen tilvalg]</span>
              }
              @if (!selectedAbonnement?.isTilkaldsabonnement) {
                @for (tilvalgGroup of selectedTilvalgGroups; track tilvalgGroup) {
                  <span class="orange absolute" @fadeSlideInOut>
                    @if (getNewTilvalg(tilvalgGroup)) {
                      <span>
                        [{{ getNewTilvalg(tilvalgGroup) }}]
                        <br />
                      </span>
                    }
                    <br />
                  </span>
                }
              }
            </div>
            <div class="margin--top-l">
              <strong>Næste eftersyn</strong>
              <br />
              @if (!serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
                {{ serviceaftale.naesteEftersynDate | date: 'dd.MM.yyyy' }}
                <br />
              }
              @if (serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
                Ingen eftersyn
                <br />
              }
              @if (
                selectedAbonnement &&
                !selectedAbonnement?.isTilkaldsabonnement &&
                serviceaftale?.naesteEftersynDate != naesteEftersynDate.value
                ) {
                <span
                  class="orange absolute"
                  @fadeSlideInOut
                  >
                  [{{ naesteEftersynDate.value | date: 'dd.MM.yyyy' }}]
                </span>
              }
              @if (
                selectedAbonnement &&
                selectedAbonnement?.isTilkaldsabonnement &&
                serviceaftale?.naesteEftersynDate != naesteEftersynDate.value
                ) {
                <span
                  class="orange absolute"
                  @fadeSlideInOut
                  >
                  [Ingen eftersyn]
                </span>
              }
            </div>
            <div class="margin--top-l">
              <strong>Opkrævningsdato</strong>
              <br />
              @if (!serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
                {{ serviceaftale.opkraevningDate | date: 'dd.MM.yyyy' }}
                <br />
              }
              @if (serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
                Ingen opkrævningsdato
                <br />
              }
              @if (
                selectedAbonnement && !selectedAbonnement?.isTilkaldsabonnement && serviceaftale?.opkraevningDate != opkraevningDate.value
                ) {
                <span
                  class="orange absolute"
                  @fadeSlideInOut
                  >
                  [{{ opkraevningDate.value | date: 'dd.MM.yyyy' }}]
                </span>
              }
              @if (
                selectedAbonnement && selectedAbonnement?.isTilkaldsabonnement && serviceaftale?.opkraevningDate != opkraevningDate.value
                ) {
                <span
                  class="orange absolute"
                  @fadeSlideInOut
                  >
                  [Ingen opkrævningsdato]
                </span>
              }
            </div>
            <div class="margin--top-l">
              <strong>Serviceinterval</strong>
              <br />
              @if (!serviceaftale?.serviceAbonnement?.isTilkaldsabonnement) {
                {{ serviceaftale?.serviceAbonnement?.eftersynInterval }} mdr.
                <br />
              }
              @if (serviceaftale?.serviceAbonnement?.isTilkaldsabonnement) {
                Ingen serviceinterval
                <br />
              }
              @if (selectedAbonnement && !selectedAbonnement?.isTilkaldsabonnement) {
                <span class="orange absolute" @fadeSlideInOut>
                  [{{ eftersynInterval.value }} mdr.]
                </span>
              }
              @if (selectedAbonnement && selectedAbonnement?.isTilkaldsabonnement) {
                <span class="orange absolute" @fadeSlideInOut>
                  [Ingen serviceinterval]
                </span>
              }
            </div>
            <div class="margin--top-l">
              <strong>Serviceperiode</strong>
              <br />
              {{ $safeNavigationMigration(serviceaftale?.currentServiceinterval?.startDate) | date: 'dd.MM.yyyy' }}-{{
              $safeNavigationMigration(serviceaftale?.currentServiceinterval?.endDate) | date: 'dd.MM.yyyy'
              }}
              <br />
              @if (selectedServiceinterval) {
                <span class="orange absolute" @fadeSlideInOut>
                  [{{ $safeNavigationMigration(selectedServiceinterval?.startDate) | date: 'dd.MM.yyyy' }}-{{ $safeNavigationMigration(selectedServiceinterval?.endDate) | date: 'dd.MM.yyyy' }}]
                </span>
              }
            </div>
            <div class="margin--top-l">
              <strong>Opkrævningsinterval</strong>
              <br />
              @if (!serviceaftale?.serviceAbonnement?.isTilkaldsabonnement) {
                <span>{{ serviceaftale?.effectiveOpkraevningsinterval }} mdr.</span>
                <br />
              }
              @if (serviceaftale?.serviceAbonnement?.isTilkaldsabonnement) {
                Ingen opkrævningsinterval
                <br />
              }
              @if (
                selectedAbonnement &&
                !selectedAbonnement.isTilkaldsabonnement &&
                effectiveOpkraevningsinterval != serviceaftale.effectiveOpkraevningsinterval
                ) {
                <span
                  class="orange absolute"
                  @fadeSlideInOut
                  >
                  [{{ effectiveOpkraevningsinterval }} mdr.]
                </span>
              }
              @if (selectedAbonnement && selectedAbonnement.isTilkaldsabonnement) {
                <span class="orange absolute" @fadeSlideInOut>
                  [Ingen opkrævningsinterval]
                </span>
              }
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #stepHeader>
        <div class="flow__header icon-with-text">
          <mat-icon class="icon-32" [svgIcon]="getProductText(serviceaftale)"></mat-icon>
          Skift {{ getProductText(serviceaftale) }} abonnement
        </div>
      </ng-template>
    </div>
  }
  @if (quickViewOpen) {
    <div class="quick-view" [@inOutAnimation]>
      <button type="button" class="btn-icon btn-close" (click)="quickViewOpen = false" title="Luk">
        <mat-icon>close</mat-icon>
      </button>
      <app-quickview [serviceaftale]="serviceaftale"></app-quickview>
      <div class="quick-view__bottom">
        <button mat-raised-button color="primary" [routerLink]="['/aftale', serviceaftale.okKundeAftaleNr]">Åben aftalen</button>
      </div>
    </div>
  }
